import axios from "axios";
import { api } from "./api_route";

export const createSec17InterimOrdersAPI = async (sec17InterimOrdersData) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      sec17InterimOrdersData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/sec17InterimOrder/create`,
      sec17InterimOrdersData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getSec17InterimOrdersByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(`${api}/sec17InterimOrder/case/${caseID}`);
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateSec17InterimOrdersAPI = async (
  sec17InterimOrders_ID,
  sec17InterimOrdersData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      sec17InterimOrdersData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/sec17InterimOrder/update/${sec17InterimOrders_ID}`,
      sec17InterimOrdersData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteSec17InterimOrdersAPI = async (sec17InterimOrders_ID) => {
  try {
    const response = await axios.delete(
      `${api}/sec17InterimOrder/delete/${sec17InterimOrders_ID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const createSec17RevocationRequestAPI = async (
  sec17RevocationRequestData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      sec17RevocationRequestData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/sec17InterimOrder/sec17RevocationRequest/create`,
      sec17RevocationRequestData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getSec17RevocationRequestByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(
      `${api}/sec17InterimOrder/sec17RevocationRequest/case/${caseID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateSec17RevocationRequestAPI = async (
  sec17RevocationRequest_ID,
  sec17RevocationRequestData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      sec17RevocationRequestData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/sec17InterimOrder/sec17RevocationRequest/update/${sec17RevocationRequest_ID}`,
      sec17RevocationRequestData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteSec17RevocationRequestAPI = async (
  sec17RevocationRequest_ID,
) => {
  try {
    const response = await axios.delete(
      `${api}/sec17InterimOrder/sec17RevocationRequest/delete/${sec17RevocationRequest_ID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteSec17RevocationRequestDocumentAPI = async (documentID) => {
  try {
    const response = await axios.delete(
      `${api}/sec17InterimOrder/sec17RevocationRequest/document/delete/${documentID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const sec17RevocationRequestDocumentDownload = async (values) => {
  try {
    const response = await axios.get(
      `${api}/documents/sec17RevocationRequestDocuments/${values.original.documentNewName}`,
      {
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    return [];
  }
};
// Document Categories Constants
export const REVOCATIONREQUEST_DOCUMENT_CATEGORIES = {
  SUPPORTINGDOCUMENTS: 1623,
};

export const DOCUMENT_CATEGORY_LABELS = {
  1623: "supportingDocuments",
};
